import React, { useEffect, useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Breadcrumb } from '@lockerpm/design';

import itemsComponents from '../items';

import { getRoutersByLocation } from "../../utils/common";

import '../css/breadcrumb.scss';

function LayoutBreadcrumb() {
  const { RouterLink } = itemsComponents;
  const { t } = useTranslation();
  const location = useLocation();

  const [menus, setMenus] = useState([])
  const selectedWorkspace = useSelector((state) => state.workspace.selectedWorkspace);
  const selectedProject = useSelector((state) => state.project.selectedProject);
  const currentPage = useSelector((state) => state.system.currentPage);
  const userInfo = useSelector((state) => state.auth.userInfo);
  const locale = useSelector((state) => state.system.locale);

  useEffect(() => {
    if (location) {
      const brRouters = getRoutersByLocation(location);
      const lastRouter = brRouters.slice(-1)[0];
      if (lastRouter && lastRouter.parent === 'PROJECTS' && selectedProject?.id == currentPage?.params?.project_id) {
        let lastMenus = [lastRouter]
        if (lastRouter.children) {
          const lastRouterChild = lastRouter.children.find((m) => m.key === currentPage.name)
          lastMenus = [
            {
              ...lastRouter.children[0],
              label: t(lastRouter?.label)
            },
            {
              ...lastRouterChild,
              label: t(lastRouterChild?.label)
            }
          ]
        }
        setMenus([
          ...brRouters.filter((m) => m.key !== lastRouter.key),
          {
            key: 'PROJECT_SECRETS',
            label: selectedProject?.name
          },
          ...lastMenus
        ]);
      } else {
        setMenus(brRouters);
      }
    }
  }, [location, selectedProject, currentPage, locale])

  const items = useMemo(() => {
    const breadcrumbRouters = menus.map((m, index) => ({
      key: index,
      title: index === menus.length - 1 ? <span>
        {t(m.label)}
      </span> : <RouterLink
        label={t(m.label)}
        routerName={m.router || m.key}
        routerParams={currentPage.params}
        routerQuery={currentPage.query}
        maxWidth={120}
      />
    }))
    if (currentPage.name.includes('ACCOUNT_')) {
      return [
        {
          key: 'account',
          title: <span>
            {userInfo?.full_name}
          </span>
        },
        ...breadcrumbRouters
      ]
    }
    if (selectedWorkspace && currentPage.params.workspace_id) {
      return [
        {
          key: 'workspace',
          title: <span>
            {selectedWorkspace.name}
          </span>
        },
        ...breadcrumbRouters
      ]
    }
    return breadcrumbRouters
  }, [menus, selectedWorkspace, currentPage, userInfo, locale])

  return (
    <Breadcrumb className='flex items-center' items={items}>
    </Breadcrumb>
  )
}

export default LayoutBreadcrumb;